import { env } from './env'

export const PUBLIC_PATH_PREFIX = '/public'

export function buildPublicPath(slug: string): string {
  return `${PUBLIC_PATH_PREFIX}/${slug}`
}

export function buildPublicEventPath(slug: string, eventId: string): string {
  return `${buildPublicPath(slug)}/events/${eventId}`
}

export function buildPublicUrl(slug: string): string {
  const origin =
    typeof window !== 'undefined' && window.location ? window.location.origin : ''
  return `${origin}${buildPublicPath(slug)}`
}

export function buildPublicEventUrl(slug: string, eventId: string): string {
  return `${env.publicBaseUrl}${buildPublicEventPath(slug, eventId)}`
}
